<div class="component-name-formula-builder full-width">
  <div class="row justify-end">
    <button (click)="addFormula()" [disabled]="selectedFormulaParts?.length===0" mat-raised-button color="primary"
      ><i class="fa fa-plus" style="margin-right:10px;"></i> Add another formula
    </button>
  </div>
  <div class="row auto" style="clear:both;">
    <div class="row auto flex-third">
      <mat-form-field>
        <mat-label>Select or enter a date format</mat-label>
        <mat-select [(ngModel)]="dateFormat" (selectionChange)="onPredefinedSelected($event.value)">
          @for (format of predefinedDateFormats; track format) {
            <mat-option [value]="format">{{format}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="with-error">
        <mat-label>Custom date format</mat-label>
        <input matInput [formControl]="customDateFormat" (input)="onCustomFormatInput($event)"
               placeholder="e.g. YYYY-MM-DD">
        <i matSuffix [matMenuTriggerFor]="dateFormatKey" class="fa fa-info-circle date-format-info"
           matTooltip="Click for token reference"></i>
        @if (customDateFormat.hasError('invalidDateFormat')) {
          <mat-error>
            Enter a valid date/time format - at least one date/time token (e.g. YYYY) plus separators - _ / . : or space.
          </mat-error>
        }
      </mat-form-field>
      <button (click)="addDateToFormula(selectedDateFormatToAdd)"
              [disabled]="!selectedDateFormatToAdd || customDateFormat.invalid || hasDate()"
              class="btn-addtotext"
              [title]="hasDate() ? 'Only one date part is allowed per formula' : 'Add to formula'">
      </button>
    </div>

    <div class="row flex-third">
      <mat-form-field>
        <mat-label>Choose your formula item separator</mat-label>
        <mat-select [(ngModel)]="selectedSeparator">
          @for (separator of availableSeparators; track separator.symbol) {
            <mat-option [value]="separator.symbol">{{separator.symbol + ' (' + separator.title + ')'}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button (click)="addSeparatorToFormula(selectedSeparator)"
              class="btn-addtotext" title="Add to formula"></button>
    </div>
    <div class="row flex-third formula-count">
      <mat-form-field>
        <mat-label>Add 'Count' at specific position</mat-label>
        <input disabled matInput type="text" value="Count">
      </mat-form-field>
      <button (click)="addCountToFormula()" [disabled]="hasCount()"
              class="btn-addtotext" title="Add count to formula (once only)"></button>
    </div>
  </div>
  <div class="row center">
    <div class="row center flex-two-thirds">
      <select-search-component
          [value]="selectedConstantProperty"
          [api_model]="'constant_property_light'"
          (selectionChange)="selectedConstantProperty=$event.value"
          [custom_filters]="constantPropertyFilter"
          label="Select one or more Constant Properties"
          [classes]="'fill'"
          class="select-search">
      </select-search-component>
      <button (click)="addPropertyToFormula(selectedConstantProperty)" [disabled]="!selectedConstantProperty"
              class="btn-addtotext form-element-align"
              matTooltip="Add Constant Property to formula"></button>
    </div>

  <div class="row center flex-third">
    <mat-form-field>
      <mat-label>Add fixed text</mat-label>
      <input matInput #textInput type="text" placeholder="Freeform text">
    </mat-form-field>
    <button (click)="addTextToFormula(textInput.value); textInput.value=''"
      class="btn-addtotext form-element-align"
    matTooltip="Add fixed text to formula"></button>
  </div>
</div>

<h3 class="row">
  <div>Formula:</div>
  <div>
    <button mat-flat-button class="text-btn"
      (click)="listOrientation=listOrientation==='horizontal'?'vertical':'horizontal';"
      matTooltip="Change formula list orientation">
      @if (listOrientation==='horizontal') {
        <span class="material-symbols-outlined">swap_vert</span>
      }
      @if (listOrientation==='vertical') {
        <span class="material-symbols-outlined">swap_horiz</span>
      }
    </button>
    <button mat-flat-button class="text-btn" (click)="reset()" matTooltip="Start over">
      <span class="material-symbols-outlined">refresh</span>
    </button>
  </div>
</h3>


<div cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListOrientation]="listOrientation" class="formula-list"
  [ngClass]="listOrientation">
  @for (part of selectedFormulaParts; track part; let i = $index) {
    <div cdkDrag class="formula-item" [ngClass]="part.type">
      @if (part.type !== 'constant_property') {
        <div>{{part.content}}</div>
      }
      @if (part.type === 'constant_property') {
        <div>
          <div class="stage-item stage" [ngClass]="{'item-loaded':cpDict[part.content]}">
            <div class="dot-flashing"></div>
          </div>
          {{(cpDict[part.content]?.attributes) | nameOrDescription}}
        </div>
      }
      <button (click)="removeItem(i)">X</button>
    </div>
  }
</div>

<component-name-formula-table [(nameFormulas)]="config.name_formulas"
  [selectedKey]="selectedKey"
  [cpDict]="cpDict"
  (formulaDeleted)="formulaDeleted($event)"
  (formulaSelected)="formulaSelected($event)">

</component-name-formula-table>

</div>

<mat-menu #dateFormatKey="matMenu" class="date-format-key">
  <div><b>YYYY</b>: 4-digit year (e.g., 2026)</div>
  <div><b>YY</b>: 2-digit year (e.g., 26)</div>
  <div><b>MMMM</b>: Full month name (e.g., January)</div>
  <div><b>MMM</b>: 3-letter month name (e.g., Jan)</div>
  <div><b>MM</b>: Zero-padded month number (e.g., 01)</div>
  <div><b>M</b>: Month number without a zero (e.g., 1)</div>
  <div><b>DD</b>: Zero-padded day of the month (e.g., 02)</div>
  <div><b>D</b>: Day of the month without a zero (e.g., 2)</div>
  <div><b>dddd</b>: Full day name (e.g., Tuesday)</div>
  <div><b>ddd</b>: 3-letter day name (e.g., Tue)</div>
  <div><b>d</b>: Day of the week number starting at Sunday as 0 (e.g., 2)</div>
  <div><b>HH</b>: 24-hour format with leading zero (e.g., 13)</div>
  <div><b>H</b>: 24-hour format without leading zero (e.g., 13)</div>
  <div><b>hh</b>: 12-hour format with leading zero (e.g., 01)</div>
  <div><b>h</b>: 12-hour format without leading zero (e.g., 1)</div>
  <div><b>mm</b>: Minutes with a leading zero (e.g., 05)</div>
  <div><b>m</b>: Minutes without a leading zero (e.g., 5)</div>
  <div><b>ss</b>: Seconds with a leading zero (e.g., 09)</div>
  <div><b>s</b>: Seconds without a leading zero (e.g., 9)</div>
  <div><b>Separators</b>: '-' '_' '/' '.' ':' ' '</div>
</mat-menu>
